<template>
  <div class="buttom">
        <div class="Footer_beian" style="border:none;padding-top:15px">
           <span class="">COPYRIGHT ©  2026
            <a href="http://beian.miit.gov.cn"  target="_blank">豫ICP备2023013918号-1
            </a> </span>
      
      <span class="Footer_mobileHidden">
          <img src="../assets/img/bot1.png" alt="bot1" class="img">
          <img src="../assets/img/bot2.png" alt="bot1" class="img">
        </span>
        </div>
  </div>
</template>

<script>
export default {

}
</script>


<style lang="scss" scoped>
.buttom{
  margin-top: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.Footer_beian{
  color: #666;
  display: flex;
  font-size: 16px;
  align-items: center;
}
.Footer_mobileHidden{
  .img{
    width: auto;
    margin: 0 10px;
    height: 18px;
  }
}
</style>